import React, { useContext } from 'react'
import Context from '../../context'

function DeleteModal({ handleDelete }) {
  const { modalData } = useContext(Context)

  return (
    <div
      className="modal fade"
      id="deleteModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered " role="document">
        <div className="modal-content alert alert-danger">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              Favor confirmar a exclusão do {modalData.type} <strong>{modalData.title}</strong>
            </h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-dismiss="modal">
              Cancelar
            </button>
            <button
              type="button"
              data-dismiss="modal"
              className="btn btn-danger"
              onClick={handleDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteModal
